import { styled } from '@mui/material/styles';
import { Box, Typography, Table, TableCell, TableRow } from '@mui/material';

// ============================================
// Page Layout
// ============================================
export const PageContainer = styled(Box)({
  padding: '32px',
});

export const PageTitle = styled(Typography)({
  fontSize: '22px',
  fontWeight: 600,
  color: '#262626',
  marginBottom: '8px',
});

export const PageDescription = styled(Typography)({
  fontSize: '14px',
  color: '#8c8c8c',
  marginBottom: '24px',
});

// ============================================
// Table
// ============================================
export const TableWrapper = styled(Box)({
  overflowX: 'auto',
  border: '1px solid #e5e5e5',
  borderRadius: '8px',
});

export const StyledTable = styled(Table)({
  minWidth: '900px',
});

export const HeaderCell = styled(TableCell)({
  backgroundColor: '#f5f5f5',
  fontSize: '13px',
  fontWeight: 600,
  color: '#595959',
  whiteSpace: 'nowrap',
});

export const BodyCell = styled(TableCell)({
  fontSize: '14px',
  color: '#262626',
  whiteSpace: 'nowrap',
});

export const StyledTableRow = styled(TableRow)({
  '&:last-child td': {
    borderBottom: 0,
  },
  '& > *:first-of-type': {
    paddingLeft: '24px',
  },
});

export const YnBadge = styled(Box, {
  shouldForwardProp: prop => prop !== 'active',
})(({ active }) => ({
  display: 'inline-block',
  minWidth: '36px',
  textAlign: 'center',
  padding: '2px 8px',
  borderRadius: '4px',
  fontSize: '12px',
  fontWeight: 600,
  ...(active
    ? { backgroundColor: '#fde3e3', color: '#d93025' }
    : { backgroundColor: '#f0f0f0', color: '#8c8c8c' }),
}));

export const CheckMessagePreview = styled(Typography)({
  fontSize: '13px',
  color: '#8c8c8c',
  maxWidth: '220px',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
});

// ============================================
// Edit Modal
// ============================================
export const ModalBox = styled(Box)({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '520px',
  maxWidth: '95vw',
  backgroundColor: '#fff',
  borderRadius: '8px',
  overflow: 'hidden',
});

export const ModalHeader = styled(Box)({
  height: '56px',
  backgroundColor: '#262626',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '0 24px',
});

export const ModalTitle = styled(Typography)({
  fontSize: '18px',
  fontWeight: 600,
  color: '#fff',
});

export const ModalBody = styled(Box)({
  padding: '24px',
  display: 'flex',
  flexDirection: 'column',
  gap: '20px',
});

export const FieldRow = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
});

export const FieldLabel = styled(Typography)({
  fontSize: '14px',
  fontWeight: 500,
  color: '#262626',
});

export const FieldHint = styled(Typography)({
  fontSize: '12px',
  color: '#bfbfbf',
});

export const ModalFooter = styled(Box)({
  display: 'flex',
  justifyContent: 'flex-end',
  gap: '12px',
  padding: '16px 24px',
  borderTop: '1px solid #f0f0f0',
});
